import { handleApiCall } from "../api";

export const getOrderDetails = (page, storeId) =>
  handleApiCall("get", `orders?page=${page}&limit=10&store_id=${storeId}`);

export const viewOrderDetails = (id: any, isLoading?: boolean) =>
  handleApiCall("get", `orders/${id}`, null, {}, isLoading);

export const createOrderDetails = (payload: any) =>
  handleApiCall("get", "orders", payload);

export const getCancelReasons = () =>
  handleApiCall("get", "order-cancel-reasons");

export const createCancelOrder = (id: number, payload: any) =>
  handleApiCall("patch", `orders/${id}/cancel`, payload);

export const createCartDetails = (payload: any) =>
  handleApiCall("post", `orders/cart`, payload);

export const createCancelInvoice = (payload: any) =>
  handleApiCall("post", `/orders/create-invoice`, payload);

export const createBilledInvoice = (payload: any) =>
  handleApiCall("post", `/orders/create-invoice`, payload);

// Accept a Tazty order without the items the store cannot supply.
export const acceptPartialOrder = (
  orderId: number | string,
  payload: {
    cancel_items: { buyer_order_item_id: number; quantity: number }[];
    cancel_reason_id: number;
    preparation_time?: string;
  },
) => handleApiCall("post", `/orders/${orderId}/accept-partial`, payload);

export const setPreparationTime = (payload: any) =>
  handleApiCall("post", `orders/preparation-time`, payload);

// Create Shipment
export const createCalculateShipment = (payload: any) =>
  handleApiCall("post", "invoices/calculate-rate", payload);

export const createShipment = (postPayload: any) =>
  handleApiCall("post", `/invoices/create-shipment`, postPayload);

// Download Shipment Packed
export const packingLabel = (id: any, config = {}) =>
  handleApiCall("get", `/invoices/${id}/packing-label`, config);

// New: status-specific services for tabs
export const getNewOrders = (page: any, storeId: any, status?: string, isLoading: boolean = true) =>
  handleApiCall(
    "get",
    `/orders?page=${page}&limit=10&store_id=${storeId}&search=pending`,
    null,
    {},
    isLoading
  );

export const getPreparingOrders = (page: any, storeId: any, status?: string, isLoading: boolean = true) =>
  handleApiCall(
    "get",
    `/invoices?page=${page}&limit=10&store_id=${storeId}&status=billed&status=agent-assigned&status=agent-arrived-restaurant&isPacked=false`,
    null,
    {},
    isLoading
  );

export const getReadyOrders = (page: any, storeId: any, status?: string, isLoading: boolean = true) =>
  handleApiCall(
    "get",
    `/invoices?page=${page}&limit=10&store_id=${storeId}&status=packed&status=picked&status=out-for-delivery&status=agent-assigned&status=agent-arrived-restaurant&isPacked=true`,
    null,
    {},
    isLoading
  );

export const getDeliveredOrders = (page: any, storeId: any, status?: string) =>
  handleApiCall(
    "get",
    `/invoices?page=${page}&limit=10&store_id=${storeId}&search=delivered`
  );

export const getCompletedOrders = (
  page: any,
  storeId: any,
  status?: string,
  fromDate?: string,
  toDate?: string
) => {
  let url = `/orders?page=${page}&limit=10&store_id=${storeId}`;

  if (fromDate && toDate) {
    url += `&from_date=${fromDate}&to_date=${toDate}`;
  } 
  
  if (status === "all") {
    url += `&status=completed&status=cancelled`;
  } else {
    url += `&search=${status}`;
  }

  return handleApiCall("get", url);
};

// export const getFiltersOrders = (page: any, storeId: any, status?: string, search?: string) =>
// 	handleApiCall("get", `/orders?page=${page}&limit=10&store_id=${storeId}&search=${search}`);

export const getInvoiceDownload = (id: number) =>
  handleApiCall("get", `/invoices/pdf/${id}/download`, {
    responseType: "blob",
  });

// Download invoice PDF
export const downloadInvoicePdf = (invoiceId: number) =>
  handleApiCall("get", `/invoices/pdf/${invoiceId}/download`, {
    responseType: "blob",
  });

// Exotel API - Initiate call
export const initiateExotelCall = (payload: {
  order_id: string;
  from: string;
  to: string;
}) => handleApiCall("post", "/exotel", payload);

// Payment Refund (manual record)
export const paymentRefund = (invoiceId: number, payload: any) => {
  return handleApiCall("patch", `/invoices/${invoiceId}/payment-refund`, payload)
};

// Refund (Super Admin / Super User). mode: wallet | normal | instant_company |
// instant_buyer. include_gst decides whether the item GST goes back (per refund).
export const razorpayRefund = (
  invoiceId: number,
  payload: { mode: string; include_gst?: boolean; reason?: string },
) => {
  return handleApiCall("post", `/invoices/${invoiceId}/razorpay-refund`, payload)
};

// What a refund would pay out, plus the refund defaults. Moves no money.
export const getRefundPreview = (
  invoiceId: number,
  params: { mode?: string; include_gst?: boolean } = {},
) => {
  const query = new URLSearchParams();
  if (params.mode) query.set("mode", params.mode);
  if (typeof params.include_gst === "boolean") query.set("include_gst", String(params.include_gst));
  const qs = query.toString();
  // No global loader: the dialog shows its own spinner.
  return handleApiCall(
    "get",
    `/invoices/${invoiceId}/refund-preview${qs ? `?${qs}` : ""}`,
    null,
    {},
    false,
  )
};